import { render, staticRenderFns } from "./SaleInvoiceTemplate5.vue?vue&type=template&id=6da3861c&"
import script from "./SaleInvoiceTemplate5.vue?vue&type=script&lang=js&"
export * from "./SaleInvoiceTemplate5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports